export default {
  name: 'OurWorkCard',
  props: {
    dashboard_path: {
      type: String,
      default: '/dsd_dashboard'
    }
  }
};